import { render, staticRenderFns } from "./BreedPage.vue?vue&type=template&id=2dc6d829&scoped=true&"
import script from "./BreedPage.vue?vue&type=script&lang=js&"
export * from "./BreedPage.vue?vue&type=script&lang=js&"
import style0 from "./BreedPage.vue?vue&type=style&index=0&id=2dc6d829&scoped=true&lang=css&"
import style1 from "./BreedPage.vue?vue&type=style&index=1&id=2dc6d829&scoped=true&lang=scss&"
import style2 from "./BreedPage.vue?vue&type=style&index=2&id=2dc6d829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc6d829",
  null
  
)

export default component.exports